import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import SnakeBlock from "../SnakeBlock";
import ConnectorBlock from "../ConnectorBlock";
import { checkCurrentMemory } from "../../utils/localStorage";
import { getUserCurrentDate } from "../../utils/getUserCurrentDate";
import PreSolutionCheckModal from "../Modal/PreSolutionCheckModal";
import { getDateUSAFormat } from "../../utils/getUserCurrentDate";

const MobileShare = ({ blocks, isMobile, puzzleDate }) => {
    const memory = checkCurrentMemory();
    const today = getUserCurrentDate();
    const gameStatus = memory?.gameStatus;
    const lastDayPlayed = memory?.lastDayPlayed;
    const defaultShowSnake = (lastDayPlayed && lastDayPlayed === today) && (gameStatus ===  'game won' || gameStatus === 'game over');

    const [showSnake, setShowSnake] = useState(defaultShowSnake);

    const navigate = useNavigate();

    const createSnake = () => {
        return (
            <div>
                {
                    blocks.map((block, idx) => {
                        return (
                            <React.Fragment key={block.id ?? idx}>
                                <SnakeBlock showGoBack={() => console.log(idx)} info={block} />
                                {(idx !== blocks.length - 1 && !block.strike) && <ConnectorBlock isMobile={isMobile} height={50} color={'black'} />}
                            </React.Fragment>
                        )
                    })
                }
            </div>
        )
    }

    return (
        <div style={{backgroundColor: 'black' }}>
            <p style={{ fontWeight: 'bolder', fontSize: 24, color:'#ccc', margin:0, padding:10 }}>I solved the snake on <br/> {getDateUSAFormat(puzzleDate)} in {Math.max(0, (blocks?.length ?? 0) - 2)} moves!</p>
            <div
                style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', width: '100%', overflowY: 'scroll' }}>
                    {showSnake ?
                        createSnake()
                    :
                        <PreSolutionCheckModal show={true} showSolution={() => setShowSnake(true)} />
                    }
            </div>
            {!showSnake && <div style={{height:200}}/>}
            <div style={{ paddingBottom: '20px', textAlign: 'center' }}>
                <button
                    style={{
                        padding: '10px 20px',
                        fontSize: '16px',
                        fontWeight: 'bold',
                        color: 'white',
                        backgroundColor: '#282c34',
                        border: 'none',
                        borderRadius: '5px',
                        cursor: 'pointer',
                        marginTop: '20px'
                    }}
                    onClick={() => navigate('/')}>
                    {gameStatus === 'game won' ? 'Back to my Puzzle' : 'Let Me Try'}
                </button>
            </div>
        </div>
    );
}

export default MobileShare;